import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import { useStartXeroSignIn } from '@/services/api/auth/useXeroSignIn'

/**
 * Target of the Xero Sign In widget's link. Normally the click is intercepted
 * and the flow starts in place; this route covers a direct visit / new tab.
 */
export default function XeroSignInStartPage() {
  const navigate = useNavigate()
  const started = useRef(false)
  const { action } = useStartXeroSignIn()

  useEffect(() => {
    if (started.current) return
    started.current = true
    action().catch(() => navigate('/login', { replace: true }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="pf-auth grid min-h-screen px-4">
      <Card className="w-full max-w-md place-self-center">
        <CardHeader>
          <CardTitle>Sign in with Xero</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Redirecting to Xero…</p>
        </CardContent>
      </Card>
    </div>
  )
}
